import { render } from "./HospitalMaster.vue?vue&type=template&id=216ada4d&scoped=true"
import script from "./HospitalMaster.vue?vue&type=script&lang=js"
export * from "./HospitalMaster.vue?vue&type=script&lang=js"

import "./HospitalMaster.vue?vue&type=style&index=0&id=216ada4d&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216ada4d"]])

export default __exports__